import { colorPalette } from '../../style/colorPalette'
import { StatusChip } from '../../components/data-display/StatusChip'

// プロジェクト系ステータス（PROJECT / GROUP 行）の配色。
// 色は WBS パレットに合わせる（STANDBY=ToDo / INPROGRESS=Doing /
// FINISHED=Done / CANCELED=Discard）。ラベルは値をそのまま表示する。
const getProjectStatusStyles = (status: string) => {
  switch (status) {
    case 'STANDBY':
      return {
        backgroundColor: colorPalette.monotone[1],
        textColor: colorPalette.monotone[4],
        borderColor: `1px solid ${colorPalette.monotone[2]}`,
      }
    case 'INPROGRESS':
      return {
        backgroundColor: colorPalette.yellow[1],
        textColor: colorPalette.yellow[4],
        borderColor: `1px solid ${colorPalette.yellow[2]}`,
      }
    case 'FINISHED':
      return {
        backgroundColor: colorPalette.skyBlue[1],
        textColor: colorPalette.skyBlue[7],
        borderColor: `1px solid ${colorPalette.skyBlue[2]}`,
      }
    case 'CANCELED':
      return {
        backgroundColor: colorPalette.monotone[3],
        textColor: colorPalette.monotone[0],
        borderColor: `1px solid ${colorPalette.monotone[3]}`,
      }
    default:
      return {
        backgroundColor: colorPalette.monotone[0],
        textColor: colorPalette.monotone[10],
        borderColor: `1px solid ${colorPalette.monotone[10]}`,
      }
  }
}

type ProjectStatusChipProps = {
  status: string
}

export const ProjectStatusChip = ({ status }: ProjectStatusChipProps) => {
  const { backgroundColor, textColor, borderColor } =
    getProjectStatusStyles(status)
  return (
    <StatusChip
      label={status}
      backgroundColor={backgroundColor}
      textColor={textColor}
      borderColor={borderColor}
    />
  )
}
